//React Imports
import React, { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
//Libs Imports
import { FormControl } from '@material-ui/core';
import jwtDecode from 'jwt-decode';
import { Table } from '..';
//Components Imports
import ActivityIndicator from '../ActivityIndicator';
import Pagination from '../atoms/pagination';
import { DISTRIBUTORS_USERS_HEADERS } from '../../constants/table-headers';
//Hooks Imports
import useGetDistributorUser from '../../hooks/distributorUser/useGetDistributorUser';
import useDeleteDistributorUser from '../../hooks/distributorUser/useDeleteDistributorUser';
import useGetDistributorUsers from '../../hooks/distributorUser/useGetDistributorUsers';
import useGetDistributors from '../../hooks/distributors/useGetDistributors';
import { ApplicationState } from '../../store';
//Styles Imports

import DeleteModal from '../Modal/ModalDelete';
import BoxWrapper from '../atoms/boxWrapper';

const TableUsersInAdmin: React.FC = () => {
  const history = useHistory();
  const [modalFlag, setModalFlag] = useState(false);
  const [id, setId] = useState('');
  // const { execute: filter } = useGetDistributorUser();
  const { execute: loadUser } = useGetDistributorUser();
  const { execute, loading } = useGetDistributorUsers();
  const [currentPage, setCurrentPage] = useState(1);
  const { execute: executeDistributors, loading: loadingDistributors } =
    useGetDistributors();
  const token = useSelector(
    (state: ApplicationState) => state.auth.token || state.distributor.token,
  );
  const tokenDecoded: any = jwtDecode(token);
  const { distributors } = useSelector(
    (state: ApplicationState) => state.tables,
  );

  const {
    execute: executeDeleteDistributorUser,
    loading: loadingDistributorUser,
  } = useDeleteDistributorUser();

  const { distributorUsers } = useSelector(
    (state: ApplicationState) => state.tables,
  );

  const onNavigationClick = (path: string) => {
    history.push(path);
  };

  const loadUsers = useCallback(async () => {
    await execute({
      page: currentPage,
      distributorUserId: tokenDecoded.distributorId,
    });
  }, [currentPage]);

  const loadDistributors = useCallback(async () => {
    await executeDistributors(currentPage);
  }, [currentPage]);

  useEffect(() => {
    loadDistributors();
    //eslint-disable-next-line
  }, [loadDistributors]);

  useEffect(() => {
    loadUsers();
    //eslint-disable-next-line
  }, [loadUsers]);

  const getDistributorUser = async (id: string) => {
    await loadUser(tokenDecoded.distributorId, id);
    onNavigationClick(`/home/users-admin/edit/${id}`);
  };
  if (loading || loadingDistributors || loadingDistributorUser) {
    return <ActivityIndicator />;
  }

  const deleteUser = async (distributorUserId: string) => {
    await executeDeleteDistributorUser(distributorUserId);
    await loadUsers();
    setModalFlag(false);
  };

  if (loading || loadingDistributors || loadingDistributorUser) {
    return <ActivityIndicator />;
  }

  return (
    <BoxWrapper>
      <DeleteModal
        message="Deseja excluir este usuários?"
        onHide={() => setModalFlag(false)}
        show={modalFlag}
        onConfirmClick={() => deleteUser(id)}
      />

      <FormControl
        style={{
          marginRight: 2,
        }}
        variant="outlined"
        fullWidth
      ></FormControl>
      <Table
        columns={DISTRIBUTORS_USERS_HEADERS}
        data={distributorUsers.rows || []}
        onEditClick={(id: string) => getDistributorUser(id)}
        onDeleteClick={(id: string) => {
          setModalFlag(true);
          setId(id);
        }}
      />
      <Pagination
        totalRecords={distributorUsers.totalRecords}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        rowsPerPage={1}
      />
    </BoxWrapper>
  );
};

export default TableUsersInAdmin;
